import { IAuthor } from '@/src/assets/interfaces/authorInterface'
import React, { FC } from 'react'
import styles from './SignSection.module.scss'
import AuthorLabel from '../authorLabel/AuthorLabel';
import ShareBlock from '../shareBlock/ShareBlock';
import { IMeta } from '@/src/assets/interfaces/metaInterface';


type TSignSection = {
    author: IAuthor
    update: string
    meta: IMeta
    title: string
    description: string
    logo: string
}

const SignSection: FC<TSignSection> = ({author, update, meta, description, title, logo}) => {

    return (
        <section className={styles.sign__section}>
            <AuthorLabel author={author} isFullInfo/>
            <ShareBlock 
                update={update} 
                meta={meta} 
                title={title}
                description={description}
                logo={logo}
                className={styles.share}
            />
        </section>
    )
}

export default SignSection